module.exports = __webpack_public_path__ + "static/media/album.9ac4f673.svg";